// extracted by mini-css-extract-plugin
export default {"loaderContainer":"MobileLoader_loaderContainer__q+UwS","loader":"MobileLoader_loader__7C+AT"};